
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findhhsRecordByPersonId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findhhsRecordByPersonId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playerName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"playerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homeClubName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homeClubId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lowHcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lowHcpiFreezeUntil"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentHcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calculatedHcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"proWithHcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpiLock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpiLockComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpiBreak"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpiLockUpdated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpiBreakUpdated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"proWithHcpiUpdated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoringRecordItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"round"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"par"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pcc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slopeRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"holes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"playForm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustedGrossScore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snpv"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"playingHcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoreDifferential"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseHcpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resultStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentClub"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tournamentType"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":811}};
    doc.loc.source = {"body":"query findhhsRecordByPersonId($personId: String!) {\n  findhhsRecordByPersonId(input: {\n    personId: $personId\n  }) {\n    playerName\n    playerId\n    homeClubName\n    homeClubId\n    lowHcpi\n    lowHcpiFreezeUntil\n    currentHcpi\n    calculatedHcpi\n    proWithHcpi\n    hcpiLock\n    hcpiLockComment\n    hcpiBreak\n    hcpiLockUpdated\n    hcpiBreakUpdated\n    proWithHcpiUpdated\n    scoringRecordItems {\n      id\n      date\n      courseName\n      courseId\n      tournamentName\n      tournamentId\n      round\n      par\n      courseRating\n      pcc\n      slopeRating\n      holes\n      playForm\n      adjustedGrossScore\n      snpv\n      hcpi\n      playingHcpi\n      scoreDifferential\n      adjustment\n      comment\n      courseHcpi\n      resultStatus\n      country\n      tournamentClub\n      tournamentType\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["findhhsRecordByPersonId"] = oneQuery(doc, "findhhsRecordByPersonId");
        
